import React from "react";
import PropTypes from "prop-types";

export default function HeaderNotify(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7259 14.6229L14.7692 13.9852V8.44922C14.7692 4.92495 12.0606 2.02178 8.61539 1.7099V0.615234C8.61539 0.275461 8.33986 0 8 0C7.66014 0 7.38462 0.275461 7.38462 0.615234V1.7099C3.93941 2.02178 1.23077 4.92495 1.23077 8.44922V13.9852L0.274051 14.6229C0.10281 14.737 0 14.929 0 15.1348V17.5957C0 17.9355 0.275528 18.2109 0.615385 18.2109H15.3846C15.7245 18.2109 16 17.9355 16 17.5957V15.1348C16 14.929 15.8971 14.737 15.7259 14.6229Z"
        fill={props.fill}
      />
      <path
        d="M5.15824 19.4414C5.76185 20.3783 6.80976 21 8 21C9.1902 21 10.2382 20.3783 10.8417 19.4414H5.15824Z"
        fill={props.fill}
      />
    </svg>
  );
}
HeaderNotify.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};
HeaderNotify.defaultProps = {
  className: "",
  fill: "#063AC9",
  width: 16,
  height: 21,
  onClick: () => null
};
